import { Component, OnInit, ViewChild } from '@angular/core';
//import { ChartType } from 'angular-google-charts';
import { MessageService } from 'primeng/api';
import { CarteraService } from '../../../services/cartera/cartera.service';
import { TiendaService } from '../../../services/tienda/tienda.service';


@Component({
  selector: 'app-resumen-ventas',
  templateUrl: './resumen-ventas.component.html',
  styleUrls: ['./resumen-ventas.component.scss'],
  standalone: false,
  providers: [MessageService]
})
export class ResumenVentasComponent implements OnInit {

  load: boolean = false;
  loadMenu: boolean = true;
  dateQuery: Date = new Date();
  today: Date = new Date();
  @ViewChild('calendar') calendar: any;
  lsTienda: Array<any> = [];
  infoVentaSales: Array<any> = []
  tiendaSelected: any = {};
  token: any = {};
  infoUser: any = {};
  display: boolean = false;
  display1: boolean = false;
  messageSales: String = "";
  rangeDates: Date[] = [new Date(), new Date()];
  isVisibleBtnMeta: boolean = true;
  //********* */ representación del grafico*********/
  @ViewChild("chart") chart: any;
  chartOptions: any = [];

  constructor(private tienda: TiendaService,
    private cartera: CarteraService,
    private message: MessageService) { }

  ngOnInit(): void {
    this.token = JSON.parse(localStorage.getItem('token') ?? "".toString());
    this.infoUser = JSON.parse(localStorage.getItem('infoUser') ?? "[]");
    this.lsTienda = JSON.parse(localStorage.getItem('tiendas') ?? "[]");
    this.getInfoVentas(false);
    // configuration graphique
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor1 = documentStyle.getPropertyValue('--primary-color');
    const textColor3 = documentStyle.getPropertyValue('--green-500');
    this.chartOptions = {
      chart: {
        width: 400,
        type: "pie"
      },
      series: [0, 0],
      labels: ["Venta actual", "Faltante a la meta"],
      fill: {
        colors: [textColor3, textColor1]
      }
    }
  }




  promiseGetInfoVentas = () => {


    return new Promise((resolve: any) => {
      const dateConvertBegin: string = this.rangeDates[0].getFullYear() + '-' + (this.rangeDates[0].getMonth() + 1) + "-" + this.rangeDates[0].getDate();
      const dateConvertEnd: string = this.rangeDates[1].getFullYear() + '-' + (this.rangeDates[1].getMonth() + 1) + "-" + this.rangeDates[1].getDate();

      Promise.all(this.lsTienda.map((row) => {
        return new Promise((resolve1: any) => {
          //consultar la informaciòn de resumen de pago de cada tienda segun la fecha
          this.tienda.getVentasDiscriminacionPagoTiendaAcumulado(this.token.token, dateConvertBegin, dateConvertEnd, row.idTienda).subscribe((response) => {
            let temp = response as Array<any>;
            let valorVentas: Array<number>;
            let valorTotal: number = 0;
            valorTotal = temp.map(i => {
              // las nota credito no ingresan en el valor total de la venta
              return (i.idVentaMetodoPago != 4) ? i.valor : 0;
            }).reduce((a, b) => { return a + b }, 0);

            row.discriminacionPagos = temp;
            row.valorTotal = valorTotal;

            // obetener los valores de las metas
            this.tienda.getMetasTiendaAcumulado(this.token.token, dateConvertBegin, dateConvertEnd, row.idTienda).subscribe((data: any) => {
              /******************************Configuration Graphique ************************************************/
              row.meta = data[0].valor;
              row.chartOptions = {
                series: [row.valorTotal, ((data[0].valor - row.valorTotal) < 0) ? 0 : data[0].valor - row.valorTotal]
              };
              // obtener los abonos a cartera
              row.totalAbonos = 0;
              this.cartera.getAbonosCartera(this.token.token, dateConvertBegin, dateConvertEnd, row.idTienda).subscribe((resp1: any) => {
                row.infoAbonosCartera = resp1 as Array<any>;
                row.infoAbonosCartera.forEach((item: any) => {
                  row.totalAbonos += item.valor;
                });
              })
              resolve1('OK');
            });
          });
        });

      })
      ).then((values) => {
        resolve('listo');
      })

    });
  }

  getInfoVentas = (isToday: boolean) => {
    this.promiseGetInfoVentas().then(() => {
      this.lsTienda.sort((a: any, b: any) => {
        return (b.meta ?? -1 < b.valorTotal ? b.valorTotal : b.valorTotal - b.meta) - (a.meta ?? -1 < a.valorTotal ? a.valorTotal : a.valorTotal - a.meta);
      });
    });

  }

  asignarMetas = () => {
    this.display = true;
    this.lsTienda.forEach(element => {
      element.valorMeta = element.metaTienda.length == 0 ? 0 : element.metaTienda[0].valor
    });
  }

  hideDisplay = () => {
    if (new Date(this.today).getTime(), new Date(this.dateQuery).getTime())
      this.getInfoVentas(true)
    else
      this.getInfoVentas(false)
  }

  iniMeta = (index: number) => {
    this.lsTienda[index].set = false;
  }

  setMeta = (index: number) => {
    if (!!this.lsTienda[index].valorMeta) {
      const data = {
        idMetaTipo: 1,
        idTienda: this.lsTienda[index].idTienda,
        fecha: this.dateQuery.getFullYear() + '-' + (this.dateQuery.getMonth() + 1) + "-" + this.dateQuery.getDate(),
        referencia: "Venta del día",
        valor: this.lsTienda[index].valorMeta
      }
      this.tienda.setMetas(this.token.token, data).subscribe({
        next: (response) => {
          this.lsTienda[index].set = true;
        }, error: (error: Response) => {
          this.lsTienda[index].set = false;
        }
      })
    }

  }

  showInfoDetail = (index: number) => {
    this.tiendaSelected = this.lsTienda[index];
    this.display1 = true;
    const dateConvertBegin: string = this.rangeDates[0].getFullYear() + '-' + (this.rangeDates[0].getMonth() + 1) + "-" + this.rangeDates[0].getDate();
    const dateConvertEnd: string = this.rangeDates[1].getFullYear() + '-' + (this.rangeDates[1].getMonth() + 1) + "-" + this.rangeDates[1].getDate();
    // obtener las ventas por vendedor
    this.messageSales = "<div class='p-message p-message-success'>Cargando información de ventas...</div>"
    this.tienda.getVentasDiscriminacionVendedorAcumulado(this.token.token, dateConvertBegin, dateConvertEnd, this.lsTienda[index].idTienda).subscribe((response) => {
      this.infoVentaSales = response as Array<any>;
      this.messageSales = "";
    })
  }

  validateMeta = () => {
    if (this.rangeDates[1] != null) {
      const dateConvertBegin: string = this.rangeDates[0].getFullYear() + '-' + (this.rangeDates[0].getMonth() + 1) + "-" + this.rangeDates[0].getDate();
      const dateConvertEnd: string = this.rangeDates[1].getFullYear() + '-' + (this.rangeDates[1].getMonth() + 1) + "-" + this.rangeDates[1].getDate();
      const today: string = this.today.getFullYear() + '-' + (this.today.getMonth() + 1) + "-" + this.today.getDate();

      if ((dateConvertBegin == dateConvertEnd) && (dateConvertBegin == today))
        this.isVisibleBtnMeta = true;
      else
        this.isVisibleBtnMeta = false;

      this.calendar.overlayVisible = false;
    }
  }

}
